<template>
  <div :class="['axiome-logique-container', 'axiome-logique-has-self']">
    <!--Affichage OnProperty-->
    <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />

    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">some
      self</span>
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeHasSelf",
  computed: {
    hasSelfLiterals() {
      let result = [];
      this.hasSelf.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    hasSelf: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    }
  }
}
</script>
